import { render } from "./AccountDetailsView.vue?vue&type=template&id=1d21adc7&scoped=true"
import script from "./AccountDetailsView.vue?vue&type=script&lang=js"
export * from "./AccountDetailsView.vue?vue&type=script&lang=js"

import "./AccountDetailsView.vue?vue&type=style&index=0&id=1d21adc7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d21adc7"]])

export default __exports__